import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import PPForm from "./PPForm";
import PPWizardDefinePPRuleAndPreview from "./PPWizardDefinePPRuleAndPreview";
import { PPWizardStore, PPWizardStoreContext } from "./PPWizardStore";

export const NewPPWizard: FunctionComponent<WizardModalDialogProps<PPWizardStore>> = observer((props) => {
	const {
		actionController,
		onSave,
		onClose,
		...otherProps
	} = props;

	// create the local store for child components so that the store can be shared among pages
	const loc = useLocale();
	const store = useLocalReactionStore(() => new PPWizardStore(loc, actionController, onClose, onSave));
	const { index } = store || {};

	return (
		<>
			{store && (
				<PPWizardStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus={index === 0}
						fullHeight={index === 1}
						pages={[PPForm, PPWizardDefinePPRuleAndPreview]}
						store={store}
						supportStepInformation
						width={index === 1 ? 1200 : null}
					/>
				</PPWizardStoreContext.Provider>
			)}
		</>
	);
});

export default NewPPWizard;